import clsx from "clsx";
import { useState } from "react";
import { IconText } from "components/IconText";

export function usePasswordToggle(type: string) {
    const [inputType, setInputType] = useState(type);
    const [isVisible, setIsVisible] = useState(false);

    const toggle = () => {
        if (isVisible) {
            setInputType(type);
        } else {
            setInputType("text");
        }
        setIsVisible(!isVisible);
    };

    const toggleButton =
        type === "password" ? (
            <button type="button" className="btn btn-dark icon-link" onClick={toggle}>
                <IconText icon={clsx("fas", inputType === "password" ? "fa-eye" : "fa-eye-slash")} />
            </button>
        ) : null;

    return { inputType, toggleButton };
}
